import React from "react";
import "./styles.css";
//import { AiOutlineSearch } from "react-icons/ai";
//import { IoIosArrowDown } from "react-icons/io";
//import { Collapse } from "react-collapse";
import api from "./../../../services/api";
import {NavLink} from 'react-router-dom';
import SideNav from './../../../components/SideNav_RI';
import { user_token } from '../../../services/Auth';
import Grid from '@material-ui/core/Grid';
import GetAgent from './GetAgent';
import GetExam from './GetExam';

import {agent} from '../../../services/api';
let apiAgent = new agent();

var _id = localStorage.getItem("id_agent");
var token = localStorage.getItem(user_token);

export default class RI_PacientesDetalhes extends React.Component {

    state = {
        paciente: [],
    }

    componentDidMount(){
        this.loadData();
    }

    loadData = async () => {
        const { id } = this.props.match.params;
        console.log(id);
        //const request = await api.get(`/user/${id}`, {headers: {'x-access-token': token}});
        const request = await apiAgent.getUser(id);
        console.log(request);
        console.log(request.data);
        this.setState({ paciente: request.data });
    
      };

    render() {
        return (
        <>
        <SideNav />
        <div id="top-RI-Cadastro">
        <Grid container spacing={0} direction="row" justify="left"  alignItems="center" style={{ marginTop: '-35vh'}}>
            <Grid item xs={2} sm={2} md={1} lg={1} align="center"></Grid>
            <Grid item xs={8} sm={8} md={10} lg={10}></Grid>   
            <Grid item xs={2} sm={2} md={1} lg={1} align="center"></Grid>
        </Grid>
        </div>
          <Grid container spacing={0} direction="row" justify="left"  alignItems="center">
          <Grid item xs={12} sm={12} md={10} lg={3} align="center"></Grid>
          <Grid item xs={12} sm={12} md={10} lg={6} align="center">
          <div id="main-RI-Consulta-Pendente">
          <h1 id="title">Detalhes do paciente</h1>
          <br></br>
          <div id="lista-style">
          {this.state.paciente.map(details => (
          <> 
            <div id="exam">
              <h1 id="tittle-forms-cme">Dados do Paciente</h1>
              <hr id="coloring_line"/>
              <p id="RI-Title-Cadastro-Paciente">Identificação:</p><p>{details.numericID}</p>
              <p id="RI-Title-Cadastro-Paciente">Nome:</p><p>{details.name}</p>
              {details.user_type === "Paciente" ? <> <p id="RI-Title-Cadastro-Paciente">Tipo de paciente:</p><p>Paciente da instituição</p></>:
               details.user_type === "Funcionario" ? <> <p id="RI-Title-Cadastro-Paciente">Tipo de paciente:</p><p>Funcionário da instituição</p></> :
              null}
              <p id="RI-Title-Cadastro-Paciente">Data de Nascimento: </p><p>{details.birth}</p>
              <p id="RI-Title-Cadastro-Paciente">Gênero: </p><p>{details.gender}</p>
              <p id="RI-Title-Cadastro-Paciente">CPF: </p><p>{details.cpf}</p>
              <p id="RI-Title-Cadastro-Paciente">Endereço:</p><p>{details.adress}</p>
              <hr id="coloring_line"/>
              <br></br>
              <br></br>
              <h1 id="tittle-forms-cme">Histórico de Consultas</h1>
              <GetExam id={details._id} />
              <br></br>
                         
              <h1 id="tittle-forms-cme">Dados do Representante de Instituição</h1>
              <hr id="coloring_line"/>
               
              <GetAgent id={_id} />
              <hr id="coloring_line"/>
              <br></br>
              <div id="forms-ps-justify">
              <NavLink to={{pathname: '/RI_SolicitarConsulta/' + details._id}}>
                <button id="option-RI-Cadastro-Paciente">Solicitar Consulta</button></NavLink>
              </div>
              <br></br>
            </div>
          </>
          ))}
        </div>
        </div>
        </Grid>
        </Grid>
      </>
        );
    }
}


/*
export default function RI_PacientesDetalhes() {
    let [search, setSearch] = useState(false);
    let [login, setLogin] = useState(false);
  
    return(
        <>
        <SideNav />
         <div id="top-RI-Cadastro">
                <NavLink id="RI-cadastro" to="/RI_PacientesLista"><button id="exit-RI-Cadastro">Voltar</button></NavLink>
                <div style={{display:"flex", flexDirection:"row"}}>
                    <Collapse isOpened={search}>
                        <input id="RI-Cadastro-Search" placeholder="pesquisar..." />
                    </Collapse>
                    <AiOutlineSearch
                        size={"6vh"}
                        onClick={() =>
                            setSearch(!search)
                        }
                        id="Icon-Search-RI-Cadastro"
                    />
                </div>
            </div>
            <div id="main-RI-Detalhes-Paciente">
                <p id="RI-Detalhes-Paciente">Detalhes do paciente</p> 
                <hr id="divider-RI-Detalhes-Paciente" />
                <div id="arrow-RI-Detalhes-Paciente">
                    <IoIosArrowDown
                        onClick={() =>
                            setLogin(!login)
                        }
                        size={"6vh"}
                        id="IconDown-RI-Detalhes-Paciente"
                    />
                </div>
                <Collapse isOpened={login}>
                    <GetDetailsUser />
                </Collapse>
            </div>
        </>
    );
}
*/